import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmailServiceService } from '../service/email-service.service';

@Component({
	selector: 'app-get-email',
	templateUrl: './get-email.page.html',
	styleUrls: ['./get-email.page.scss'],
})
export class GetEmailPage implements OnInit {
	loader = true;

	data: any;

	templateId: string | null = '';

	init = {
		selector: 'textarea', // change this value according to your HTML
		forced_root_block: 'div',
		plugins: 'code',
	};

	constructor(
		private emailServiceService: EmailServiceService,
		private route: ActivatedRoute,
	) {}

	ngOnInit() {
		this.templateId = this.route.snapshot.paramMap.get('id');

		if (this.templateId) {
			this.reloadImg(this.templateId);
		}
	}

	reloadImg(templateId: string | null) {
		this.emailServiceService
			.getEmailTemplateById(templateId)
			.subscribe(data => {
				this.loader = false;
				this.data = data;
			});
	}
	updateEmailTemplate() {
		this.emailServiceService
			.updateEmailTemplate({
				courseId: Number(this.data.courseID),
				emailTemplate: this.data.email_template,
				subject: this.data.subject,
				body: this.data.body,
			})
			.subscribe(data => {
				this.reloadImg(this.templateId);
			});
	}
}
